module.exports = __webpack_public_path__ + "img/m2_petofi.86b815f3.png";